(function(angular){
	'use strict';
	
	angular.module('popoverModule', [
		'BaseConfig'
	]);
})(window.angular);